if (!customElements.get("tabs-component")) {
  customElements.define(
    "tabs-component",
    class TabsComponent extends HTMLElement {
      static ICON_PLUS = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>`;
      static ICON_MINUS = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>`;

      connectedCallback() {
        const items = this.parseSource();
        this.render(items);
        this.initTabs();
        this.initAccordion();
        this.equalizeTabPanels();
      }

      parseSource() {
        const items = [];
        const dl = this.querySelector("dl");
        if (!dl) return items;

        let current = null;
        dl.childNodes.forEach((node) => {
          if (node.nodeName === "DT") {
            current = { id: node.dataset.tab, label: node.innerHTML, content: "" };
            items.push(current);
          } else if (node.nodeName === "DD" && current) {
            current.content = node.innerHTML;
          }
        });
        return items;
      }

      render(items) {
        this.innerHTML = `
          <nav class="tabs-nav">
            ${items
              .map(
                (item, i) => `
              <button data-tab="${item.id}" class="${i === 0 ? "active" : ""}">
                ${item.label}
              </button>
            `,
              )
              .join("")}
          </nav>
          <div class="tabs-panels">
            ${items
              .map(
                (item, i) => `
              <div class="tab-panel ${i === 0 ? "active" : ""}" id="tab-${item.id}">
                ${item.content}
              </div>
            `,
              )
              .join("")}
          </div>
          <div class="accordion">
            ${items
              .map(
                (item, i) => `
              <div class="accordion-item">
                <button class="accordion-trigger ${i === 0 ? "active" : ""}" data-accordion="${item.id}">
                  ${item.label}
                  <span class="accordion-trigger__icon">
                    <span class="accordion-trigger__icon-plus">${TabsComponent.ICON_PLUS}</span>
                    <span class="accordion-trigger__icon-minus">${TabsComponent.ICON_MINUS}</span>
                  </span>
                </button>
                <div class="accordion-panel ${i === 0 ? "active" : ""}" id="accordion-${item.id}">
                  ${item.content}
                </div>
              </div>
            `,
              )
              .join("")}
          </div>
        `;
      }

      initTabs() {
        this.querySelectorAll(".tabs-nav button").forEach((btn) => {
          btn.addEventListener("click", () => {
            this.querySelectorAll(".tabs-nav button").forEach((b) => b.classList.remove("active"));
            this.querySelectorAll(".tab-panel").forEach((p) => p.classList.remove("active"));
            btn.classList.add("active");
            this.querySelector(`#tab-${btn.dataset.tab}`).classList.add("active");
          });
        });
      }

      equalizeTabPanels() {
        const panels = this.querySelectorAll(".tab-panel");
        const container = this.querySelector(".tabs-panels");
        if (!panels.length || !container) return;

        const recalculate = () => {
          const activePanel = container.querySelector(".tab-panel.active");
          panels.forEach((p) => p.classList.add("active"));
          container.style.minHeight = "";
          let maxHeight = 0;
          panels.forEach((p) => { maxHeight = Math.max(maxHeight, p.offsetHeight); });
          panels.forEach((p) => p.classList.remove("active"));
          if (activePanel) activePanel.classList.add("active");
          container.style.minHeight = maxHeight + "px";
        };

        recalculate();

        if (typeof ResizeObserver !== "undefined") {
          new ResizeObserver(recalculate).observe(this);
        }
      }

      initAccordion() {
        this.querySelectorAll(".accordion-trigger").forEach((btn) => {
          btn.addEventListener("click", () => {
            const isOpen = btn.classList.contains("active");
            this.querySelectorAll(".accordion-trigger").forEach((b) => b.classList.remove("active"));
            this.querySelectorAll(".accordion-panel").forEach((p) => p.classList.remove("active"));
            if (!isOpen) {
              btn.classList.add("active");
              this.querySelector(`#accordion-${btn.dataset.accordion}`).classList.add("active");
            }
          });
        });
      }
    },
  );
}
